import { Button, Modal } from "@scuf/common";

export const UploadNotePopup = (props: any) => {
  const { showPopup, setShowPopup, handleConfirmUpload } = props;
  return (
    <Modal
      className="modal-content-dataManagement-wrapper"
      open={showPopup}
      onClose={() => setShowPopup(false)}
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
      closeIcon={true}
    >
      <span className="modal-text-dataManagement">
        Please make sure that the file being uploaded is not password protected.
        Such files will be removed by the system after upload. The file size
        limit is less than 2 GB.
        <br />
      </span>
      <Modal.Footer className="modal-footer-dataManagement">
        <Button
          type="secondary"
          size="small"
          content="Cancel"
          onClick={() => setShowPopup(false)}
          className="cancel-secondary-dataManagement"
        />

        <Button
          type="secondary"
          size="small"
          content="Continue"
          onClick={() => {
            setShowPopup(false);
            handleConfirmUpload();
          }}
          className="save-secondary-dataManagement"
        />
      </Modal.Footer>
    </Modal>
  );
};
